export enum BldConditionSelectionEnum {
  "あり他社" = "あり（他社）",
  "あり自社" = "あり（自社）",
  "なし" = "なし"
}
